export const changeUser = (user) => {
    return (dispatch) =>  {
        dispatch({
            type: 'CHANGE_USER',
            payload: user
        })
    }
}